import e from "react";
import { c as d, t as m } from "./app-a75c1d35.mjs";
import { V as S } from "./VideoIcon-87fb4a33.mjs";
import { L as H } from "./Link-479ac100.mjs";
import { B as D } from "./Button-c598cb52.mjs";
import { W as N } from "./Icon-3122c134.mjs";
import { B as x, a as h } from "./Block-9b78bd10.mjs";
import { I, a as _ } from "./Image-d6406817.mjs";
import "./index-615eb227.mjs";
import "./LinkContext-0c83848a.mjs";
import "./useClickOutside-726e7c36.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
const b = "registration", B = "registration__video-container", w = "registration__information", P = "button", u = {
  registration: b,
  registrationVideoContainer: B,
  registrationInformation: w,
  button: P
};
function W(c) {
  const {
    eventStartDate: s,
    eventEndDate: t,
    eventLocation: r,
    eventLink: n,
    translations: o = {},
    locale: a
  } = c, {
    location: v = "Location",
    time: g = "Time",
    link: p = "Register"
  } = o, { textDate: E, isMultiDayEvent: L } = A(
    s,
    t,
    a
  ), l = L ? void 0 : $(s, t, a);
  return /* @__PURE__ */ e.createElement("span", { className: u.registration }, /* @__PURE__ */ e.createElement("div", { className: u.registrationVideoContainer }, /* @__PURE__ */ e.createElement(
    S,
    {
      src: "/static/videos/Icon_Calendar.mp4",
      fallbackImgSrc: "/static/images/Icon_Calendar.svg"
    }
  )), /* @__PURE__ */ e.createElement(
    "dl",
    {
      className: d(
        u.registrationInformation,
        m.textsLeadText
      )
    },
    /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("dt", { style: { display: "none" } }, "Date"), /* @__PURE__ */ e.createElement("dd", { className: m.textsLeadTextBold }, E)),
    l ? /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("dt", null, g, ": "), /* @__PURE__ */ e.createElement("dd", null, l)) : null,
    r ? /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("dt", null, v, ": "), /* @__PURE__ */ e.createElement("dd", null, r)) : null,
    n ? /* @__PURE__ */ e.createElement(H, { href: n, disableLinkTextStyle: !0 }, /* @__PURE__ */ e.createElement(
      D.Secondary,
      {
        asDiv: !0,
        text: p,
        icon: N.ARROW_UP_RIGHT
      }
    )) : null
  ));
}
function A(c, s, t = "en-US") {
  const r = {
    weekday: void 0,
    year: "numeric",
    month: "long",
    day: "numeric"
  }, n = c.toLocaleDateString(t, r), o = s?.toLocaleDateString(t, r), a = o ? n !== o : !1;
  return {
    textDate: a ? `${n} — ${o}` : n,
    isMultiDayEvent: a
  };
}
function $(c, s, t = "en-US") {
  const r = new Intl.Locale(t), n = {
    timeStyle: "short",
    timeZone: "Europe/Helsinki"
  }, o = c.toLocaleTimeString(r, n).toLocaleLowerCase(), a = s?.toLocaleTimeString(r, n).toLocaleLowerCase();
  return !a || a === o ? o : `${o} - ${a}`;
}
const O = "event-hero-block-content", V = "event-hero-title", G = "event-hero", U = "desktop", M = "hero-wrapper", F = "image-reference", Z = "information", j = "registration", q = "event-hero-lead-text", z = "event-hero-description", J = "event-hero-link", i = {
  eventHeroBlockContent: O,
  eventHeroTitle: V,
  eventHero: G,
  desktop: U,
  heroWrapper: M,
  imageReference: F,
  information: Z,
  registration: j,
  eventHeroLeadText: q,
  eventHeroDescription: z,
  eventHeroLink: J
};
function le(c) {
  const {
    title: s,
    image: t,
    imageReference: r,
    leadText: n,
    description: o,
    altText: a,
    isLargeDesktop: v,
    locale: g,
    eventStartDate: p,
    eventEndDate: E,
    eventLocation: L,
    eventLink: l,
    translations: f = {}
  } = c, {
    link: y = "Register"
  } = f, C = d(m.pageHeading, i.eventHeroTitle), R = d(i.imageReference), T = d(
    m.textsComponentTitleBold,
    i.eventHeroLeadText
  ), k = d(
    m.textsLeadText,
    i.eventHeroDescription
  );
  return /* @__PURE__ */ e.createElement(x, { bottomPadding: h.LARGE, topPadding: h.SMALL }, /* @__PURE__ */ e.createElement(x.Content, { className: i.eventHeroBlockContent }, /* @__PURE__ */ e.createElement("h1", { className: C }, s), /* @__PURE__ */ e.createElement("div", { className: i.heroWrapper }, /* @__PURE__ */ e.createElement(
    I,
    {
      className: i.eventHero,
      src: t.imageSrc,
      width: t.width,
      height: t.height,
      altText: a,
      imageLoader: t.imageLoader,
      styling: _.ARTICLE_PAGE_HERO,
      "data-testid": "event-page-hero-image"
    }
  ), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: R,
      "data-testid": "event-hero-image-reference"
    },
    /* @__PURE__ */ e.createElement("p", { itemProp: "citation", className: m.textsCaption }, r)
  )), /* @__PURE__ */ e.createElement(
    W,
    {
      locale: g,
      eventStartDate: p,
      eventEndDate: E,
      eventLocation: L,
      eventLink: l,
      translations: f
    }
  ), v ? /* @__PURE__ */ e.createElement("div", { className: i.information }, /* @__PURE__ */ e.createElement("p", { className: T }, n), /* @__PURE__ */ e.createElement("div", { className: k }, o)) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("p", { className: T }, n), /* @__PURE__ */ e.createElement("div", { className: k }, o), l ? /* @__PURE__ */ e.createElement("div", { className: i.eventHeroLink }, /* @__PURE__ */ e.createElement(H, { href: l, disableLinkTextStyle: !0 }, /* @__PURE__ */ e.createElement(
    D.Secondary,
    {
      asDiv: !0,
      text: y,
      icon: N.ARROW_UP_RIGHT
    }
  ))) : null)));
}
export {
  le as EventHero
};
//# sourceMappingURL=EventHero.js.map
